import dashboard from './menu/dashboard'
import setting from './menu/setting'
import conversation from './menu/conversation'
import working from './menu/working'
import management from './menu/management'

export default [
  ...dashboard,
  ...conversation,
  ...working,
  ...setting,
  ...management,
]
